export const getSavedBankConciliationDate = (businesses, businessId) => {
  if (businessId == null || String(businessId).trim() === '') {
    throw new Error('No se pudo identificar la empresa seleccionada.')
  }
  const business = Array.isArray(businesses)
    ? businesses.find(item => String(item.id) === String(businessId))
    : null
  if (!business) throw new Error('No se encontró la empresa seleccionada. Actualiza la página e inténtalo nuevamente.')
  const value = business.atributosLuca?.fechaLimiteBank
  if (value == null || value === '') return null
  const date = String(value).slice(0, 10)
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || Number.isNaN(Date.parse(date)) || new Date(date).toISOString().slice(0, 10) !== date) {
    throw new Error('La fecha de conciliación bancaria guardada para esta empresa no es válida.')
  }
  return date
}
